import * as React from 'react';
import {
    TextField,
    Button,
    Container,
    Box,
    Typography,
} from '@mui/material';
import Navbar from '../setup/Navbar';
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination';
import Loading from '../../BuiltInComponent/Loading';
import Footer from '../setup/Footer';
import { getDepartments, addDepartment, getSingleDepartment, editDepartment, deleteDepartment } from '../../features/AdminManagement/departmentSlice';
import { useDispatch, useSelector } from 'react-redux';

const Departments = () => {

    const dispatch = useDispatch();

    const { departments, isLoading } = useSelector((state) => state.dept);
    const tableColumns = [
        { fieldName: 'deptID', cName: 'deptID', textAlign: 'right', dType: 'string', status: 'en' },
        { fieldName: 'deptName', cName: 'Decpartment Description', textAlign: 'left', dType: 'string', status: 'en' },
        { fieldName: 'Edit', cName: 'Edit', width: 50, textAlign: 'center', dType: 'string', status: 'en' },
        { fieldName: 'Delete', cName: 'Delete', width: 50, textAlign: 'center', dType: 'string', status: 'en' },
        { fieldName: 'Delete', cName: 'Delete', width: 50, textAlign: 'center', dType: 'string', status: 'dis' },
    ]
    React.useEffect(() => {
        dispatch(getDepartments())
    }, [dispatch]);

    const [department, setDepartment] = React.useState({
        deptID: '',
        deptDesc: '',
        status: true,
    });

    const handleChange = (e) => {
        setDepartment({
            ...department,
            [e.target.name]: e.target.value,
        });
    };

    const onEditClick = async (deptID) => {
        dispatch(getSingleDepartment(deptID)).then((res) => {
            setDepartment(prev => ({
                ...prev,
                deptID: res.payload.deptID,
                deptDesc: res.payload.deptName,
                status: res.payload.deptStatus
            }))
        })
    }

    const onDeleteClick = async (deptID) => {
        dispatch(deleteDepartment(deptID)).then(() => {
            dispatch(getDepartments())
        })

    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (department.deptID === '') {
            dispatch(addDepartment(department)).then(() => {
                dispatch(getDepartments()).then(() => {
                    setDepartment(prev => ({
                        ...prev,
                        deptID: '',
                        deptDesc: '',
                        status: true
                    }))
                })
            })
        } else {
            console.log('edt', department)
            dispatch(editDepartment(department)).then(() => {
                dispatch(getDepartments()).then(() => {
                    setDepartment(prev => ({
                        ...prev,
                        deptID: '',
                        deptDesc: '',
                        status: true
                    }))
                })
            })
        }
    };

    return (
        <>
            <Navbar />
            <Container maxWidth='sm'>
                <Box sx={{
                    // background: 'linear-gradient(90deg, rgba(16,191,248,1) 0%, rgba(12,150,180,1) 100%)', 
                    backgroundColor: '#1E90FF',
                    mb: 3, borderRadius: 2, color: 'white', textShadow: 'black 4px 4px 10px'
                }}>
                    <Typography sx={{ textAlign: 'center', fontSize: 30, fontWeight: 'bolder' }}> Departmens</Typography>
                </Box>
                <TextField
                    id="outlined-basic"
                    label="Department Description"
                    variant="outlined"
                    name="deptDesc"
                    value={department.deptDesc}
                    onChange={handleChange}
                    fullWidth
                />
                <Button variant='contained' fullWidth sx={{ mt: 2, color: 'white', fontSize: 20, fontWeight: 'bolder' }} onClick={handleSubmit}>SAVE</Button>
                {isLoading ? <Loading /> :
                    <TableDataWithPagination
                        tableColumns={tableColumns}
                        tableData={departments && departments}
                        onEditClick={onEditClick}
                        onDeleteClick={onDeleteClick} />
                }
            </Container>
            <Footer />
        </>
    );
};

export default Departments;
